import { render, staticRenderFns } from "./totalPotongan.vue?vue&type=template&id=091598e2"
import script from "./totalPotongan.vue?vue&type=script&lang=js"
export * from "./totalPotongan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports